var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-backtop',{attrs:{"visibility-height":100}},[_c('i',{staticClass:"el-icon-caret-top",staticStyle:{"color":"#FF7F0A"}})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }